var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 239 478",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.909 404.876L36.4961 323.248C28.0682 313.644 34.9177 298.561 47.7084 298.561H190.535C193.398 298.558 196.2 299.381 198.607 300.93C201.014 302.48 202.924 304.69 204.107 307.297C205.29 309.903 205.696 312.796 205.278 315.627C204.86 318.459 203.634 321.11 201.747 323.263L130.334 404.862C128.936 406.461 127.213 407.743 125.279 408.621C123.345 409.499 121.246 409.954 119.122 409.954C116.998 409.954 114.898 409.499 112.964 408.621C111.031 407.743 109.307 406.461 107.909 404.862V404.876Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.333 73.1236L201.746 154.752C210.174 164.356 203.324 179.439 190.534 179.439L47.7072 179.439C44.8447 179.442 42.0421 178.619 39.6351 177.07C37.2281 175.52 35.3187 173.31 34.1356 170.703C32.9525 168.097 32.5458 165.204 32.9642 162.373C33.3826 159.541 34.6085 156.89 36.4949 154.737L107.908 73.1385C109.306 71.5391 111.029 70.2573 112.963 69.379C114.897 68.5007 116.997 68.0463 119.121 68.0463C121.244 68.0463 123.344 68.5007 125.278 69.379C127.212 70.2573 128.935 71.5391 130.333 73.1385V73.1236Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIconDown);
export default __webpack_public_path__ + "static/media/sortIconDown.8961b818abb00ece32cf633a8be8be9b.svg";
export { ForwardRef as ReactComponent };